import type { DictationAudioLocale } from './audio/dictationAudio';
import { WARMUP_TRIN_ID } from './warmup';
import { effectiveNiveau4Lexicon } from './niveau4Lexicon';
import { DICTATION_TRIN_ID } from './extraRounds';
import { MENTAL_IMAGERY_TRIN_ID } from './mentalImagery';
import type { Trin, UserProfile } from '../types';

/** Which pre-rendered / fallback TTS bucket to use for a lesson trin. */
export function dictationAudioLocaleForTrin(
  trin: Trin,
  user: UserProfile,
): DictationAudioLocale {
  if (trin.id === WARMUP_TRIN_ID || trin.id === MENTAL_IMAGERY_TRIN_ID) {
    return 'auto';
  }
  if (trin.id === DICTATION_TRIN_ID) {
    return user.preferences?.dictationLexicon === 'en' ? 'en' : 'da';
  }
  if (trin.tierId === 'niveau-4') {
    return effectiveNiveau4Lexicon(user) === 'en' ? 'en' : 'da';
  }
  return 'da';
}
